import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { General } from "../../../../lib/types";
import { openTooltip } from "../../../../store/actions";

import { generals } from "../../../../assets/images/generals";
import { formatNumberForceSigned } from "../../../../lib/commonFunctions";
import { isTouchScreen } from "../../../../lib/elementUtilities";

interface IProps {
  general: General;
  typeId: number;
  typeName: string;
  showDetail: any;
  selected: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions))
});

const connector = connect(null, mapDispatchToProps);

const GeneralCard = ({
  general,
  typeId,
  typeName,
  showDetail,
  selected,
  openTooltipDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const attackDetailRef = useRef<HTMLAnchorElement>(null);
  const defenceDetailRef = useRef<HTMLAnchorElement>(null);

  const handleHoverAttack = () => openTooltipDispatch({
    static: true,
    title: "Attack",
    content: `Race: <span class="positive">+${general.attack.race}</span><br />
               General skills: <span class="positive">+${general.attack.qualities}</span><br />
               Magic: <span class="${general.attack.magic < 0 ? "negative" : "positive"}">${general.attack.magic > 0 ? "+" : ""}${general.attack.magic}</span><br/>
               ${general.attack.magicMode
    ? `Magic mode${general.attack.magicMode < 0 ? " aftermath" : ""}: <span class=${general.attack.magicMode < 0
      ? "negative"
      : "positive"}>${formatNumberForceSigned(general.attack.magicMode)}</span><br />`
    : ""}               
               Technology: <span class="positive">+${general.attack.technology}</span><br/>
               Buildings: <span class="positive">+${general.attack.buildings}</span>
               ${general.attack.attackPassed ? `<br />Siege passed: <span class="negative">${general.attack.attackPassed}</span>` : ""}            
            `,
    elementRef: attackDetailRef
  });

  const handleHoverDefence = () => openTooltipDispatch({
    static: true,
    title: "Defence",
    content: `Race: <span class="positive">+${general.defence.race}</span><br />
               General skills: <span class="positive">+${general.defence.qualities}</span><br />
               Magic: <span class="${general.defence.magic < 0 ? "negative" : "positive"}">${general.defence.magic > 0 ? "+" : ""}${general.defence.magic}</span><br/>
               ${general.defence.magicMode
    ? `Magic mode${general.defence.magicMode < 0 ? " aftermath" : ""}: <span class=${general.defence.magicMode < 0
      ? "negative"
      : "positive"}>${formatNumberForceSigned(general.defence.magicMode)}</span><br />`
    : ""}
               Technology: <span class="positive">+${general.defence.technology}</span><br/>
               Buildings: <span class="positive">+${general.defence.buildings}</span>
               ${general.defence.attackPassed ? `<br />Siege passed: <span class="negative">${general.attack.attackPassed}</span>` : ""}
               ${general.defence.counterintelligence ? `<br />Counterintelligence: <span class="positive">+${general.defence.counterintelligence}</span>` : ""}
               ${general.defence.thiefActions ? `<br />Thief actions: <span class="negative">${general.defence.thiefActions}</span>` : ""}
            `,
    elementRef: defenceDetailRef
  });

  return (
    <div className="col-sm-6 col-md-3 person-col">
      <div className={`person  match-height ${selected ? "selected" : ""}`}>
        <img
          src={generals[`general${typeId}`]}
          width={60}
          height={70}
          alt="general portrait"
          className="photo"
        />
        <h4 className="subname h3">{typeName}</h4>
        <p>
          <span className="white">Level</span>&nbsp;&nbsp;<em>{general.level}</em><br/>
          <span className="white">Experience</span>&nbsp;&nbsp;<em>{general.experience}</em><br/>
          <span className="white">Attack</span>&nbsp;&nbsp;
          <em>{general.attack.sum}</em>&nbsp;
          <a
            ref={attackDetailRef}
            onMouseEnter={() => !isTouchScreen() && handleHoverAttack()}
            onMouseOver={() => !isTouchScreen() && handleHoverAttack()}
            onClick={() => isTouchScreen() && handleHoverAttack()}
          >
            <i className="icon-circle white">?</i>
          </a>
          <br/>
          <span className="white">Defence</span>&nbsp;&nbsp;
          <em>{general.defence.sum}</em>&nbsp;
          <a
            ref={defenceDetailRef}
            onMouseEnter={() => !isTouchScreen() && handleHoverDefence()}
            onMouseOver={() => !isTouchScreen() && handleHoverDefence()}
            onClick={() => isTouchScreen() && handleHoverDefence()}
          >
            <i className="icon-circle white">?</i>
          </a>
          <br/>
          <span className="white">Skill points</span>&nbsp;&nbsp;<em
          className="js-gen-points">{general.skillPoints}</em>
        </p>
        <a href="#"
           className="btn btn-blank"
           tabIndex={0}
           onClick={showDetail}
        >
          Skills
        </a>
      </div>
    </div>
  )
}

export default connector(GeneralCard);
